customElements.define('product-recommendations-cart',class ProductRecommendationsCart extends HTMLElement {
    constructor() {
        super();
    }
    update(){
        if(this.querySelector('.owl-placeholder')){
            $('.related-products .owl-carousel').owlCarousel({
                margin: 20,
                nav: false,
                loop: false,
                autoWidth: true,
                dots: true,
                rewind: true,
                onInitialized: function() {
                    $('.related-products .owl-item').css('width', '150px');
                }
            });
        }
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations-cart');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }

                if (html.querySelector('.item')) {
                    this.correctInitCarousel();
                }
                // Check and toggle .cart-summary-overlay__actions visibility
                const cartActions = document.querySelector('.cart-summary-overlay__actions');
                const cartCountElement = document.querySelector('.cart-summary-overlay__head-text span');
                if (cartActions) {
                    fetch('/cart.js')
                        .then((response) => response.json())
                        .then((cartData) => {
                            if (cartData.items.length === 0) {
                                cartActions.style.display = 'none';
                            } else {
                                cartActions.style.display = 'block';
                            }

                            if (cartCountElement) {
                                cartCountElement.textContent = `( ${cartData.item_count} )`;
                            }
                        })
                        .catch((error) => console.error('Error fetching cart data:', error));
                } else {
                    console.error('.cart-summary-overlay__actions not found in the DOM');
                }


            })
            .catch((e) => {
                console.error(e);
            });
    }
    correctInitCarousel(){
        try{
            this.initCarousel();

        }catch(e){
            const interval = setInterval( ()=> {
                try{
                    if($){
                        this.initCarousel();
                        clearInterval(interval)
                    }
                }catch (e){
                    //continue
                }

            }, 100)
        }
    }
    initCarousel() {
    this.classList.add('product-recommendations--loaded');

    let owl = $('.related-products .owl-carousel');
        owl.owlCarousel({
            margin: 20,
            nav: true,
            loop: false,
            autoWidth: true,
            dots: true,
            rewind: false,
            onInitialized: function() {
                $('.related-products .owl-item').css('width', '150px');
            }
        });

        // Improved mouse wheel scroll with smoother behavior
        // owl.on('mousewheel', '.owl-stage', function(e) {
        //     e.preventDefault();

        //     // Add a small debounce/throttle to avoid rapid scrolling
        //     if (owl.data('owl.carousel').is('animating')) {
        //         return false;
        //     }

        //     // Set a smooth transition with speed option
        //     const scrollSpeed = 300; // Adjust this value for slower/faster transitions

        //     if (e.originalEvent.deltaY < 0) {
        //         owl.trigger('next.owl.carousel', [scrollSpeed]);
        //     } else {
        //         owl.trigger('prev.owl.carousel', [scrollSpeed]);
        //     }

        //     // Optional: add a small delay to prevent rapid scrolling
        //     setTimeout(function() {
        //         owl.data('owl.carousel').state.isBusy = false;
        //     }, 200);
        // });
    }
    connectedCallback() {
        this.update()
    }
});

customElements.define('item-quantity',class ItemQuantity extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const input = this.querySelector('input');
        if(input){
            input.addEventListener('input', () => this.initQuantityActions());
        } else {
            this.addEventListener('click', () => this.initQuantityActions());
        }
    }
    async changeCart({ quantity, line, key }) {
        const formData = new URLSearchParams();

        // Add the sections you want to update
        formData.append('sections', 'cart-drawer');
        formData.append('quantity', quantity);

        // Add either line number or item key (mutually exclusive)
        if (line) {
            formData.append('line', line);
        } else if (key) {
            formData.append('id', key);
        }

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            });

            if (!response.ok) {
                const jsonRes = await response.json();
                throw new Error(jsonRes.description || 'Cart update failed');
            }

            const data = await response.json();
            // Use the same handler as add to cart for consistency
            document.documentElement.dispatchEvent(
                new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));

            var $cartDrawerContainer = $(data.sections['cart-drawer']);
            var cartDrawer = $cartDrawerContainer.find('.cart-summary-overlay');
            var rowBody = cartDrawer.find('.cart-summary-overlay__row-body')[0];
            var rowFooter = cartDrawer.find('.cart-summary-overlay__row-footer')[0];
            var barWrap = cartDrawer.find('.drawer__header_progress_bar_wrap')[0];
            var recommendations = cartDrawer.find('product-recommendations-cart')[0];


            $('.cart-summary-overlay__row-body').replaceWith(rowBody);
            $('.cart-summary-overlay__row-footer').replaceWith(rowFooter);
            $('.drawer__header_progress_bar_wrap').replaceWith(barWrap);

            var realRecommendations = document.querySelector('.cart-summary-overlay product-recommendations-cart');
            if(realRecommendations){
                realRecommendations.dataset.url = recommendations.dataset.url;
                realRecommendations?.update();
            }

            //$('.cart-summary-overlay').replaceWith(cartDrawer);
        } catch (error) {
            console.error('Cart update error:', error);
            //window.Shopify.theme.showQuickPopup(error.message, document.querySelector('[data-cart-trigger]'));
        }
    }

    initQuantityActions(){
        const input = this.closest('.cart-summary-overlay__mobile-quantity').querySelector('input');
        if(input && input.value !== '' && input.value >= 0){
            const itemKey = input.dataset.itemKey;
            const itemLine = input.dataset.itemLine;
            let quantity = parseInt(input.value);
            if(!this.classList.contains('cart-summary-overlay__quantity')){
                if(this.classList.contains('cart-summary-overlay__quantity-increase')){
                    quantity++;
                } else {
                    quantity--;
                }
            }
            if(quantity < 0) return;
            this.changeCart({ quantity: quantity, line: itemLine, key: itemKey });
        }
    }
});


customElements.define('product-card-form',class ProductCardForm extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        // window.addEventListener('load', () => {
        //     window.theme.OptionManager.initProductOptions(window.jQuery(this));
        // });
        try{
            if($){
                window.theme.OptionManager.initProductOptions(window.jQuery(this));
            }
        }catch(e){
            const interval = setInterval( ()=> {
                try{
                    if($){
                        window.theme.OptionManager.initProductOptions(window.jQuery(this));
                        clearInterval(interval);
                    }
                }catch (e){
                    //continue
                }
            }, 100)
        }
    }

});

customElements.define('gift-wrap-checkbox', class GiftWrapCheckbox extends HTMLElement {
    constructor() {
        super();
    }
    fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        };
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '.cart-summary-overlay',
            },
        ];
    }
    connectedCallback() {
        setTimeout( () => {
            this.input =  this.querySelector('input');
            this.giftWrapVariantId = this.dataset.variant;
            this.itemKey = this.dataset.itemKey;
            this.itemQuantity = this.dataset.itemQuantity;
            this.giftWrapItemKey = this.dataset.giftwrapKey;


            this.input.addEventListener('change', async () => {
                console.log(this.input, this.giftWrapVariantId, this.itemKey);
                let items = [];
                if(this.input.checked){
                    //remove non bundle item from cart
                    const bundleId = new Date().getTime();
                    const body = JSON.stringify({
                        id: this.itemKey,
                        quantity: 0
                    });
                    await fetch(`${theme.routes.cart_change_url}`, { ...this.fetchConfig(), ...{ body } });
                    //prepare item to be readed with bundleId
                    const additionalItem = {
                        id: this.itemKey.split(':')?.[0],
                        quantity: this.itemQuantity,
                        properties: {
                            ...bundleId && { _bundleId: bundleId }
                        }
                    }

                    //prepare items with gift wrap item
                    items = [
                        {
                            id: this.giftWrapVariantId,
                            quantity: this.itemQuantity,
                            properties: {
                                ...bundleId && { _bundleId: bundleId },
                            },
                        }
                    ];
                    if(additionalItem?.id){
                        items.push(additionalItem);
                    }
                } else {
                    //remove non bundle item from cart
                    const body = JSON.stringify({
                        id: this.itemKey,
                        quantity: 0
                    });
                    await fetch(`${theme.routes.cart_change_url}`, { ...this.fetchConfig(), ...{ body } });
                    //prepare items with gift wrap item
                    items = [
                        {
                            id: this.itemKey.split(':')?.[0],
                            quantity: this.itemQuantity
                        }
                    ];
                }
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ items, sections: this.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname }),
                }).then((res) => res.json()).then((response) => {
                    var $cartDrawerContainer = $(response.sections['cart-drawer']);
                    var cartDrawerArray = $cartDrawerContainer.find('.cart-summary-overlay');

                    var rowBody = cartDrawerArray.find('.cart-summary-overlay__row-body')[0];
                    var rowFooter = cartDrawerArray.find('.cart-summary-overlay__row-footer')[0];
                    var barWrap = cartDrawerArray.find('.drawer__header_progress_bar_wrap')[0];
                    var recommendations = cartDrawerArray.find('product-recommendations-cart')[0];


                    $('.cart-summary-overlay__row-body').replaceWith(rowBody);
                    $('.cart-summary-overlay__row-footer').replaceWith(rowFooter);
                    $('.drawer__header_progress_bar_wrap').replaceWith(barWrap);
                    var realRecommendations = document.querySelector('.cart-summary-overlay product-recommendations-cart');
                    if(realRecommendations){
                        realRecommendations.dataset.url = recommendations.dataset.url;
                        realRecommendations?.update();
                    }
                })
            })
        }, 100);
    }
});

customElements.define('gift-box-button', class GiftBoxButton extends HTMLElement {
    constructor() {
        super();
    }
    fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        };
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '.cart-summary-overlay',
            },
        ];
    }
    connectedCallback() {
        setTimeout( () => {
            this.button =  this.querySelector('.gift-box-button');
            this.giftWrapVariantId = this.dataset.variant;

            this.button.addEventListener('click', async () => {
                let items = [];
                //prepare items with gift wrap item
                items = [
                    {
                        id: this.giftWrapVariantId,
                        quantity: this.itemQuantity,
                    }
                ];

                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ items, sections: this.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname }),
                }).then((res) => res.json()).then((response) => {
                    var $cartDrawerContainer = $(response.sections['cart-drawer']);
                    var cartDrawerArray = $cartDrawerContainer.find('.cart-summary-overlay');

                    var rowBody = cartDrawerArray.find('.cart-summary-overlay__row-body')[0];
                    var rowFooter = cartDrawerArray.find('.cart-summary-overlay__row-footer')[0];
                    var barWrap = cartDrawerArray.find('.drawer__header_progress_bar_wrap')[0];
                    var recommendations = cartDrawerArray.find('product-recommendations-cart')[0];


                    $('.cart-summary-overlay__row-body').replaceWith(rowBody);
                    $('.cart-summary-overlay__row-footer').replaceWith(rowFooter);
                    $('.drawer__header_progress_bar_wrap').replaceWith(barWrap);
                    var realRecommendations = document.querySelector('.cart-summary-overlay product-recommendations-cart');
                    if(realRecommendations){
                        realRecommendations.dataset.url = recommendations.dataset.url;
                        realRecommendations?.update();
                    }
                })
            })
        }, 100);
    }
    hideWrapper(){
        this.style.display = 'none';
    }
    showWrapper(){
        this.style.display = 'flex';
    }
});

customElements.define('product-recommendations-add-to-cart',class ProductRecommendationsAddToCart extends HTMLElement {
    constructor() {
        super();
    }
    open(submitButton){
        if (this.checkbox) {
            this.checkbox.checked = true;
            console.log('this.productRecommendations', this.productRecommendations);
            this.productRecommendations.classList.add('modal-opened');
            submitButton.addEventListener('click', ()=> {
                setTimeout(()=> {
                    this.checkbox.checked = false;
                    this.productRecommendations.classList.remove('modal-opened');
                    this.currentButton.appendChild(this.product_form_content_clone);
                    this.content.innerHTML = '';
                },1000)
            })
        }
    }
    updateContent(button){
        console.log('button', button)
        this.currentButton = button;
        const isAutoAdd = this.currentButton.dataset.isAutoAdd === 'true';
        const product_form_content = button.querySelector('.cart-drawer-product-card-options');
        if(product_form_content){
            this.content = this.querySelector('.content .cart-drawer-product-card-options');
            if(this.content){
                this.product_form_content_clone = product_form_content.cloneNode(true);
                product_form_content.remove();
                this.content.innerHTML = this.product_form_content_clone.innerHTML.replace(' theme-init', '');
                const product_form = this.content.querySelector('.product-form');
                if(product_form){
                    console.log('inited shit', window.jQuery(product_form));
                    window.theme.OptionManager.initProductOptions(window.jQuery(product_form));
                    const submitButton = product_form.querySelector('button[type="submit"]');
                    if(isAutoAdd){
                        if(submitButton){
                            submitButton.disabled = false;
                            submitButton.click();
                        }
                    } else {
                        this.open(submitButton);
                    }
                }
            }
        }
    }
    connectedCallback() {
        setTimeout(() => {
            this.checkbox = this.querySelector('#product-recommendations-add-to-cart');
            this.productRecommendations = document.querySelector('product-recommendations-cart');
            if(this.checkbox){
                this.checkbox.addEventListener('change', () => {
                    console.log('this.productRecommendations', this.productRecommendations);
                    console.log('this.checkbox', this.checkbox)
                    if(!this.checkbox.checked){
                        this.productRecommendations.classList.remove('modal-opened');
                        this.currentButton.appendChild(this.product_form_content_clone);
                        this.content.innerHTML = '';
                    }
                })
            }
        }, 100);
    }
});

customElements.define('cart-product-form-card-button',class CartProductFormCardButton extends HTMLElement {
    constructor() {
        super();
        this.querySelector('.cd-product-form-trigger')?.addEventListener('click', () => {
            const pr_atc = document.querySelector('product-recommendations-add-to-cart');
            if(pr_atc){
                console.log('SENT');
                pr_atc.updateContent(this);
            }
        });
    }
});

function fixYayCartHeight(){
    setTimeout(() => {
        const matrix_cart = document.querySelector(':root');
        console.log(matrix_cart, window.innerHeight);
        matrix_cart.style.setProperty('--cart-height', `${window.innerHeight}px`);
    }, 500);
}

window.addEventListener('resize', () => {
    fixYayCartHeight();
})